@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss"; // for the tabular-grid-cell-layout mixin
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  overflow: auto;
  block-size: 100%;
}

.section {
  display: contents;
}

.header__field-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.tabular-grid {
  contain: size;
}
@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".data",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    2,
    3,
    4
  )
);

ch-tabular-grid.empty-result::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}
ch-tabular-grid-rowset-empty {
  // to make the loader be positioned relative to 'ch-tabular-grid-rowset-empty'
  position: relative;
}
